<template>
    <div>
        <internal-header v-if="!pdf_view" heading="CRA Working Dues Report"/>
        <c-r-a-dues-report-filters
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            v-if="!pdf_view"
        />

        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey" v-if="!pdf_view" v-show="records_are_present">
            <div @click="exportAsPdf()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer tw-w-full tw-text-right">Print Report</div>
        </div>
        <v-container
            v-show="records_are_present"
        >
            <v-row>
                <v-col>
                    {{ current_date }}
                </v-col>
            </v-row>
            <v-row>
                <v-col class="header-cells">
                    To Whom It May Concern,
                </v-col>
            </v-row>
            <v-row>
                <v-col class="header-cells" cols="1"/>
                <v-col class="header-cells" cols="3">
                    Re: {{ selected_user?.full_name }}
                </v-col>
                <v-col class="header-cells" cols="8">{{ selected_user?.functions_name }}</v-col>
            </v-row>
            <v-row>
                <v-col class="header-cells">
                    The following union dues paid to I.A.T.S.E. 667 were received from {{ selected_user?.full_name }} during the {{selected_year}} calendar year.
                </v-col>
            </v-row>
        </v-container>
        <v-container
            v-show="records_are_present"
            class="tw-mt-4 dues-container"
        >
            <v-row>
                <v-col
                    class="dues-cell dues-header"
                >
                    {{ selected_year }} Working Dues - Dates
                </v-col>
                <v-col
                    class="dues-cell dues-header"
                >
                    {{ selected_year }} Amount
                </v-col>
                <v-col
                    class="dues-cell dues-header"
                >
                    {{ selected_year }} Working Dues - Dates
                </v-col>
                <v-col
                    class="dues-cell dues-header"
                >
                    {{ selected_year }} Amount
                </v-col>
            </v-row>
            <v-row
                v-for="member_dues in member_dues"
                :key="member_dues.id"
            >
                <v-col
                    class="dues-cell"
                >
                    {{ member_dues.dues.date_left}}
                </v-col>
                <v-col
                    class="dues-cell"
                >
                    {{ member_dues.dues.amount_left}}
                </v-col>
                <v-col
                    class="dues-cell"
                >
                    {{ member_dues.dues.date_right}}
                </v-col>
                <v-col
                    class="dues-cell"
                >
                    {{ member_dues.dues.amount_right}}
                </v-col>
            </v-row>

        </v-container>

        <v-container
            v-show="records_are_present"
            class="tw-mt-4 totals-container"
            style="width: 50%"
        >
            <v-row>
                <v-col
                    class="totals-cell"
                >
                Total Working Dues {{ selected_year }}
                </v-col>
                <v-col
                    class="totals-cell tw-text-right"
                >
                ${{ total_dues }}
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    class="totals-cell tw-text-right"
                >
                *Annual Base Dues Paid
                </v-col>
                <v-col
                    class="totals-cell"
                >
                ${{ total_base_dues }}*
                </v-col>
            </v-row>
        </v-container>

        <p v-show="records_are_present" class="tw-mt-4">
            Working dues are based on a deduction of two (2%) of the gross pay (gross wage plus vacation pay) from each employee and are remitted weekly to I.A.T.S.E. 667, for each day worked under a 667 collective agreement. All working dues are capped at $2500.00 per year and any working dues contributed over that amount are returned to {{ selected_user?.full_name }}.
        </p>
        <p v-show="records_are_present">
            Please note these dues contributions are not reflected in {{ selected_user?.full_name }}'s T4 slip, however I.A.T.S.E. Local 667 issues {{ selected_user?.full_name }} a receipt for tax purposes reflecting these dues contributions. If you require further information, please do not hesitate to contact our office.
        </p>
        <br/>
        <div v-show="records_are_present">
            <div>In Solidarity,</div>
            <br/>

            <div style="width: 200px">
                <img src="/img/signature_of_business_representative.jpg" alt="Logo" width="150" height="64" class="mx-auto">
                <div class="signature-title text-center">Roman Neubacher,</div><div class="signature-title text-center">Business Representative</div>
            </div>
        </div>
    </div>
</template>

<script>
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";
    import CRADuesReportFilters from "@/Pages/InternalPages/Reports/CRADuesReportFilters.vue";

    export default {
        name: "CRADuesReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            CRADuesReportFilters,
        },
        remember: {
            data: [
                'items'
            ]
        },
        mounted() {
            this.processData(this.report_data)
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'report_data': {          // Will optionally accept a hardcoded set of data instead of getting smart table to fetch them
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    user_id: null,
                    date: null,
                },
                fetch_data_response: null,
                member_dues: null,
                base_dues: null,
                total_dues: null,
                total_base_dues: null,
                selected_user: null,
                loading: false,
                pdf_endpoint: 'reports.cradues.queue',
            }
        },
        computed: {
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            records_are_present() {
                return this.member_dues?.length || this.base_dues?.length
            },
            selected_year() {
                if(this.filters?.date!==null && this.filters?.date.length) {
                    const start = this.filters.date[0]
                    return new Date(start).getUTCFullYear()
                } else {
                    return null
                }
            },
            current_date() {
                return new Date().toDateString()
            }
        },
        methods: {
            async getData() {
                try {
                    //this.ajaxPrerequisiteCheck()
                    // Initialize state

                    if (!this.loading) {
                        this.loading = true
                        let response = null

                        // Make AJAX call using appropriate method, assign results to response
                        response = await axios.post(route('reports.list.cradues'), this.filters)        // Syntax is nicer when written for POST

                        // Ensure that we only update state with data received from the latest call, and again update state
                        if (response.data.success) {
                            this.loading = false
                            this.fetch_data_response = response
                            this.total_dues = 0
                            if(response.data?.data) {
                                this.processData(response.data.data)
                            }
                            //this.$emit('fetch-complete', response)
                        }
                        else (
                            console.log(response.data.error)
                        )
                    }

                }
                catch (error) {
                    console.log(error)
                }

            },
            formatDuesForTable(dues) {
                //split the dues into rows with 4 columns each
                //two columns are date/amouint for one record, the other two are the date.times for a second record
                const n = 2
                const size = Math.ceil(dues.length / n);
                let result = []
                for(let i=0; i < size; i++) {
                    let cols = {}
                    cols.date_left = dues[i].period_ending
                    cols.amount_left = dues[i].dues_amount
                    cols.date_right = (dues[i+size]!==undefined)?dues[i+size].period_ending:''
                    cols.amount_right = (dues[i+size]!==undefined)?dues[i+size].dues_amount:''
                    result.push(
                        {
                            id: i,
                            dues: cols
                        }
                    )
                }
                return result
            },
            async exportAsExcel() {
                // await this.$refs.report_list.getExport() /* How it's done when you want to export without queue -- Only exports visible records */
                await this.$refs.report_list.getExcel()
            },
            async exportAsPdf() {
                if (!this.pdf_endpoint) {
                    console.error('No pdf_endpoint was specified')
                    return false
                }
                let payload = this.filters
                let ajax_uri = route().check(this.pdf_endpoint) ? route(this.pdf_endpoint).url() : this.pdf_endpoint
                let ajax_method = 'post'

                axios({
                    url: ajax_uri,
                    method: ajax_method,
                    data: payload,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the PDF once it is ready.`)
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                    })
            },
            processData(data) {
                this.total_dues = 0
                if(data?.member_dues?.length > 0) {
                    const dues = data.member_dues
                    this.member_dues = this.formatDuesForTable(dues)
                    //this.total_dues += dues.map(i=>parseFloat(i.dues_amount)).reduce((a,b)=>a+b)
                    let total = 0
                    dues.forEach(element=>{
                        total += parseFloat(element.dues_amount)
                    })
                    this.total_dues += parseFloat(total.toFixed(2))
                    this.total_base_dues = total.toFixed(2)
                } else {
                    this.member_dues=null
                }
                if(data?.base_dues?.length > 0) {
                    this.base_dues = data.base_dues
                    let total = 0
                    this.base_dues.forEach(element=>{
                        total += parseFloat(element.amount_due)
                    })
                    total = parseFloat(total.toFixed(2))
                    this.total_dues += parseFloat(total.toFixed(2))
                    this.total_dues = this.total_dues.toFixed(2)
                    this.total_base_dues = total.toFixed(2)
                } else {
                    this.base_dues=null
                }
                if(data?.user) {
                    this.selected_user = data.user
                } else {
                    this.selected_user = null
                }

            }
        },
        watch: {
            filters: {
                handler(newVal, oldVal) {
                    if(newVal.user_id!==null && newVal.date!==null) {
                        this.getData()
                    }
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

.header-cells {
    padding-top: 0px;
    padding-bottom: 0px;
}
.dues-container {
    border-top: 1px solid black;
    border-left: 1px solid black;
}

.dues-header {
    font-weight: bold;
}

.dues-cell {
    border-right: 1px solid black;
    border-bottom: 1px solid black;
    text-align: center;
}

.totals-container {
    border-top: 1px solid black;
    border-left: 1px solid black;
    width: 50%;
}

.totals-cell {
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}


@media print {
    .pagebreak {
        page-break-after: always;
        min-height: 1px;
    }

    html, body {
        font-size: 10pt; /* changing to 10pt has no impact */
        margin-top: -50px;
    }

    .dues-cell {
        padding-top: 8px;
        padding-bottom: 4px;
    }

    .totals-cell {
        padding-top: 8px;
        padding-bottom: 4px;
    }

}
</style>
